<div class="flex gap-16">
  @if (!showForm && !isInEditMode()) {
    <button (click)="toggleForm()" mat-raised-button class="add-department" color="secondary">
      <svg class="icon-20"><use href="assets/images/ok-icons-sprite.svg#plus-s"></use></svg>
      Opret afdeling
    </button>
  }
  @if (!showForm && !isInEditMode()) {
    <button (click)="openDepartmentGroupDialog()" mat-button class="add-department">
      <mat-icon>group</mat-icon>
      Afdelingsgrupper
    </button>
  }
</div>
@if (showForm || isInEditMode()) {
  <form [formGroup]="departmentsForm">
    <div class="form-row margin--top-l">
      <mat-form-field>
        <mat-label>Afdelingsnavn</mat-label>
        <input type="text" matInput formControlName="departmentName" />
        @if (departmentsForm.controls['departmentName'].hasError('required')) {
          <mat-error>
            {{ getControlErrorMessage('departmentName', 'required') }}
          </mat-error>
        }
        @if (departmentsForm.controls['departmentName'].hasError('whitespace')) {
          <mat-error>
            {{ getControlErrorMessage('departmentName', 'empty') }}
          </mat-error>
        }
        @if (departmentsForm.controls['departmentName'].hasError('minlength')) {
          <mat-error>
            {{ getControlErrorMessage('departmentName', 'minLength') }}
          </mat-error>
        }
        @if (departmentsForm.controls['departmentName'].hasError('maxlength')) {
          <mat-error>
            {{ getControlErrorMessage('departmentName', 'maxLength') }}
          </mat-error>
        }
      </mat-form-field>
    </div>
    <div class="form-row">
      <div class="help-icon-wrapper">
        <mat-icon [matTooltip]="g4Info" role="img" aria-hidden="true" data-mat-icon-type="font"> help_outline </mat-icon>
      </div>
      <adm-g4-business-account-number [control]="this.departmentsForm.controls.invoicingAccountNumber" />
    </div>
    <div class="form-row">
      <div class="help-icon-wrapper">
        <mat-icon [matTooltip]="okAftaleNr" role="img" aria-hidden="true" data-mat-icon-type="font"> help_outline </mat-icon>
      </div>
      <adm-g4-agreement-number [control]="this.departmentsForm.controls.agreementNumber" [required]="false" />
    </div>
    @if (departmentGroups().length > 0) {
      <div class="form-row">
        <mat-form-field>
          <mat-label>Afdelingsgruppe</mat-label>
          <mat-select formControlName="departmentGroupId">
            <mat-option [value]="null">Ingen</mat-option>
            @for (group of departmentGroups(); track group) {
              <mat-option [value]="group.id">
                {{ group.name }}
              </mat-option>
            }
          </mat-select>
          @if (departmentsForm.controls['departmentGroupId'].hasError('required')) {
            <mat-error>
              {{ getControlErrorMessage('departmentGroupId', 'required') }}
            </mat-error>
          }
        </mat-form-field>
      </div>
    }
    <adm-dep-address-typeahead
      [parentFormGroup]="departmentsForm"
      [initialAddress]="initialAddress()"
      [addressWithoutDARValidation]="departmentsForm.controls.addressWithoutDARValidation.value"
      (addressSelected)="selectAddress($event)" />

    <div class="form-row margin--bottom-l">
      <mat-slide-toggle formControlName="addressWithoutDARValidation" color="primary">
        <div class="flex flex-col">
          Angiv lokationens adresse uden DAR validering
          <mat-hint class="hint">Brug hvis adressen f.eks. ikke findes endnu.</mat-hint>
        </div>
      </mat-slide-toggle>
    </div>
    <div class="form-row">
      <mat-slide-toggle formControlName="isHeadquarter" color="primary">Hovedkontor</mat-slide-toggle>
    </div>
    <div class="form-row flex">
      <button (click)="cancel()" class="margin--left-auto" mat-button>Annuller</button>
      @if (departmentsForm) {
        <button (click)="save()" mat-raised-button color="secondary" [disabled]="!departmentsForm.valid || isLoading">
          @if (isInEditMode()) {
            Gem
          } @else {
            Opret afdeling
          }
        </button>
      }
    </div>
  </form>
}

<div class="form-row button-flex next-button margin--top-xl">
  <button (click)="handleNextStep()" mat-raised-button color="primary">Opret adgangsgrupper</button>
</div>
